export const ARCHIVE = "archive"
export const DELETE = "delete"
